import React, { useContext, useEffect, useState } from 'react';
import { getImages } from '../const';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import ModalLayout from '../Common/ModalLayout';
import NotesModal from './NotesModal';
import CreateNoteModal from './CreateCreateNoteModal';
import PhotosUpload from '../Common/PhotosUpload';
import { VehicleContext } from '../Context/VehicleContext';
import LoadingModal from '../Common/LoadingModal';
import LiveDealershipActionForm from './LiveDealershipActionForm';
import CustomDropdown from './CustomDropdown';

const SortingTable = ({ dealershipData, handleFitAnalysisModal, isTabView, getSortedData, scoreOrder }) => {
    const { getDealershipLiveData, numberFormatter, getVautoAppraisal, updateDealerInfo } = useContext(VehicleContext);

    const [sortConfig, setSortConfig] = useState({ key: 'ranking', direction: 'descending' });

    const sortedData = React.useMemo(() => {
        let sortableData = [...dealershipData.dealership_counts || []];
        if (sortConfig !== null) {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }

        console.log(sortConfig,sortableData);
        return sortableData;
    }, [dealershipData, sortConfig]);

    useEffect(() => {
        //console.log("useEffect scoreOrder",scoreOrder);

        if(scoreOrder) requestSort('saved_rank','ascending');
        else requestSort('ranking','descending');
    },[scoreOrder])

    const requestSort = (key,use_direction='') => {
        //console.log("requested sort",key);
        let direction = use_direction == '' ? 'ascending' : use_direction;
        if (!use_direction && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const [expandedRow, setExpandedRow] = useState(null);
    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const [dealerSoldData, setDealerSoldData] = useState({});

    // console.log(dealerSoldData);

    const getSaleData = async (dealership) => {
        if (dealership in dealerSoldData) return;

        // console.log(dealerSoldData);

        const data = await getDealershipLiveData({ 'dealership': dealership, 'year': dealershipData.vin_info.year_is, 'make': dealershipData.vin_info.make_ss });

        setDealerSoldData({ ...dealerSoldData, [dealership]: data });

    };

    const openVautoAppraisal = async (vin, mileage) => {
        const data = await getVautoAppraisal({ 'vin': vin, 'mileage': mileage });

        if (data.success && data.deeplink) window.open(data.deeplink, "_blank", "noreferrer");
    }

    const handleVaDetail = () => {
        if (isTabView) {
            document.body.classList.add('body-overflow');
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    };
    const backToResultBtn = (index) => {
        document.body.classList.remove('body-overflow');
        const target = document.getElementById(`collapse${index}`);
        if (target && target.classList.contains('show')) {
            const collapseInstance = window.bootstrap.Collapse.getInstance(target) || new window.bootstrap.Collapse(target);
            collapseInstance.hide();
        }
    }
    const [sortedTableData, setSortedtableData] = useState([]);
  const [selectedIndexes, setSelectedIndexes] = useState({});

  // Initialize and sort data
  useEffect(() => {
    if (dealershipData?.dealership_counts) {
      const sorted = [...dealershipData.dealership_counts].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
      setSortedtableData(sorted);
      getSortedData(sorted);
    }
  }, [dealershipData, sortConfig]);

  const handleChange = (fromIndex, newPositionValue) => {
    const toIndex = newPositionValue - 1;

    // Don't do anything if it's already in the correct position
    if (fromIndex === toIndex) return;

    // Move the item
    const updatedData = [...sortedTableData];
    const [movedItem] = updatedData.splice(fromIndex, 1);
    updatedData.splice(toIndex, 0, movedItem);
    setSortedtableData(updatedData);

    getSortedData(updatedData);

    // Reset selectedIndexes so dropdown resets (optional)
    setSelectedIndexes({});

    //console.log(fromIndex,newPositionValue,toIndex,movedItem,updatedData);
  };
    return (
        <>
            <div className="accordion appetite-index-accordion perfect-match-accordion" id="accordionExample">

                {!isTabView && (
                    <>
                        <table className='w-100 aia-main-table pm-main-table'>
                            <thead>
                                <tr>
                                    <th
                                        className={"text-start ps-3 font-15" +
                                            sortConfig.key === 'name'
                                            ? sortConfig.direction === 'ascending'
                                                ? 'sort-asc'
                                                : 'sort-desc'
                                            : ''
                                        }
                                        onClick={() => requestSort('name')}>
                                        Dealership
                                        <span className='sort-icon pm-sort-icon ms-3'></span>
                                    </th>
                                    <th className={"text-start" +
                                        sortConfig.key === 'ranking'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                    }
                                        onClick={() => requestSort('ranking')}>
                                        PM Score
                                        <span className='sort-icon pm-sort-icon ms-3'></span>
                                    </th>
                                    <th className='text-center'>
                                        <span className='fw-700'>{dealershipData.vin_info.model_ss}</span> Sold Last <br /><span className='text-lred fw-700'>30</span> | <span className='text-lred fw-700'>90</span> Days
                                    </th>
                                    <th className='text-center'>
                                        <span className='fw-700'>{dealershipData.vin_info.model_ss} {dealershipData.vin_info.trim_ss}</span> Last <br /><span className='text-lred fw-700'>30</span> | <span className='text-lred fw-700'>90</span> Days
                                    </th>
                                    <th className={"text-center" +
                                        sortConfig.key === 'inventory_count'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                    }
                                        onClick={() => requestSort('inventory_count')}>
                                        Vehicles on Lot
                                        <span className='sort-icon pm-sort-icon ms-3'></span>
                                    </th>
                                    <th
                                        className={`text-end${sortConfig.key === 'location'
                                            ? sortConfig.direction === 'ascending'
                                                ? ' sort-asc'
                                                : ' sort-desc'
                                            : ''
                                            }`}
                                        onClick={() => requestSort('location')}
                                    >
                                        Location
                                        <span className='sort-icon pm-sort-icon ms-3'></span>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </>
                )}


                {isTabView && (
                    <>
                        <div className='d-flex align-items-center justify-content-between mob-custom-tab-th mb-1'>
                            <div>Dealership</div>
                            <div>PM Score</div>
                        </div>
                    </>
                )}
                {/* {console.log("dealershipData.dealership_counts", dealershipData.dealership_counts)} */}
                {/* console.log("sortedTableData",sortedTableData) */}
                {sortedTableData.map((item, index) => (
                    <div className='accordion-item' key={index}>
                        <h2 className='accordion-header'>
                            <table className='w-100 aia-main-table pm-main-table'>
                                <tbody>
                                    <tr className={item.live_dealership in dealershipData.live_transactions ? 'mob-add-pe' : ''}>
                                        <td className='aia-style1 text-start ps-lg-3'>
                                            <div className='d-inline-flex align-items-center aia-style-flex'>
                                                {item.live_dealership in dealershipData.live_transactions && <button
                                                    className='accordion-button collapsed pm-accordian-button d-inline-flex w-auto mob-accordion-arrow'
                                                    type='button'
                                                    data-bs-toggle='collapse'
                                                    data-bs-target={`#collapse${index}`}
                                                    aria-expanded='false'
                                                    aria-controls={`collapse${index}`}
                                                    onClick={handleVaDetail}
                                                >
                                                    <span className='aia-ac-arrow'>
                                                        {isTabView ?
                                                            <img src={getImages('gray-arrow-closed.svg')} alt='Arrow' /> :
                                                            <img src={getImages('arrow-closed.svg')} alt='Arrow' />
                                                        }
                                                    </span>
                                                </button>}
                                                <div className='text-icons-wrapper'>
                                                    <span className="text-wrapper">
                                                        <a href={"https://" + item.source_ss} target="_blank" className='text-white aia-title'>
                                                            {/* {item.name.split(" ").length > 5
                                                                ? item.name.split(" ").slice(0, 5).join(" ") + "..."
                                                                : item.name} */}
                                                            {item.name}
                                                        </a>
                                                    </span>
                                                    {!isTabView &&
                                                        <>
                                                            <div className='icons'>
                                                                {item.live_dealserhip != "" && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                    <img src={getImages('in-house.svg')} />
                                                                    <div className="tooltip-box">In-House</div>
                                                                </span>}
                                                                {!item.oem_dealer && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                    <img src={getImages('Non-OEM.svg')} />
                                                                    <div className="tooltip-box">NON OEM Dealer</div>
                                                                </span>}
                                                                {false && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                    <img src={getImages('Full_Send.svg')} />
                                                                    <div className="tooltip-box">Full Send</div>
                                                                </span>}
                                                                {item.inventory_count >= 300 && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                    <img src={getImages('Many_Vehicles.svg')} />
                                                                    <div className="tooltip-box">Big Lot</div>
                                                                </span>}
                                                                {item.gregg_dealership && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                    <img src={getImages('icon-rolodex.svg')} />
                                                                    <div className="tooltip-box">Gregg's Rolodex</div>
                                                                </span>}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                {index == 0 && <span className='best-ranking-tag text-uppercase ms-lg-3 ms-auto'>Best Match</span>
                                                }
                                            </div>
                                        </td>
                                        <td className='aia-style1 fw-900 text-start'>
                                            {isTabView ?
                                                <div>
                                                    {item.ranking.toFixed(1)}
                                                </div>
                                                :
                                                <>
                                                    <div className='d-flex align-items-center'>
                                                        {/* <select
                                                            key={index}
                                                            className="form-control cs-input-field me-4"
                                                            value={selectedIndexes[index] || ''}
                                                            onChange={(e) =>
                                                            setSelectedIndexes((prev) => ({
                                                                ...prev,
                                                                [index]: e.target.value,
                                                            }))
                                                            }
                                                        >
                                                            {Array.from({ length: dealershipData?.dealership_counts?.length }).map((_, index) => (
                                                            <option key={index} value={index + 1}>
                                                                {index + 1}
                                                            </option>
                                                            ))}
                                                        </select> */}
                                                        <div>
                                                            <CustomDropdown
                                                                dropdownLength={sortedData.length}
                                                                value={selectedIndexes[index] ?? index + 1} // ← This must be a number (1-based)
                                                                onChange={(newVal) => {
                                                                    setSelectedIndexes((prev) => ({
                                                                    ...prev,
                                                                    [index]: newVal, // ← index of row
                                                                    }));
                                                                    handleChange(index, newVal);
                                                                }}
                                                                />
                                                        </div>
                                                        <div className='gradient-circle green-circle text-center ms-4'>
                                                            <div className="gradient-circle-inside">{item.ranking.toFixed(1)}</div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </td>
                                        {!isTabView && (
                                            <>
                                                <td className='aia-style1 fw-900 text-center'>{item.model_data.thirty_day_sold} | {item.model_data.ninty_day_sold}</td>
                                                <td className='aia-style1 fw-900 text-center'>{item.trim_data.thirty_day_sold} | {item.trim_data.ninty_day_sold}</td>
                                            </>
                                        )}
                                        <td className='aia-style2 fw-500 font-20 text-center'>
                                            <div className='d-inline-flex d-block align-items-center'>
                                                <div className='mob-aia-style2'>
                                                    {isTabView && <span>Vehicles: &nbsp;&nbsp;</span>}
                                                    {item.inventory_count}
                                                </div>
                                                {isTabView &&
                                                    <>
                                                        <div className='icons'>
                                                            {item.live_dealserhip != "" && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                <img src={getImages('in-house.svg')} />
                                                                <div className="tooltip-box">In-House</div>
                                                            </span>}
                                                            {!item.oem_dealer && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                <img src={getImages('Non-OEM.svg')} />
                                                                <div className="tooltip-box">NON OEM Dealer</div>
                                                            </span>}
                                                            {false && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                <img src={getImages('Full_Send.svg')} />
                                                                <div className="tooltip-box">Full Send</div>
                                                            </span>}
                                                            {item.inventory_count >= 300 && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                <img src={getImages('Many_Vehicles.svg')} />
                                                                <div className="tooltip-box">Big Lot</div>
                                                            </span>}
                                                            {item.gregg_dealership && <span className="tooltip-container info-msg ld-info-msg ms-2">
                                                                <img src={getImages('icon-rolodex.svg')} />
                                                                <div className="tooltip-box">Gregg's Rolodex</div>
                                                            </span>}
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </td>
                                        <td className='aia-style2 text-end fw-500 pe-lg-3'>{item.location}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </h2>
                        <div
                            id={`collapse${index}`}
                            className='accordion-collapse collapse'
                            data-bs-parent='#accordionExample'
                        >
                            <div className='accordion-body'>
                                {item.live_dealership in dealershipData.live_transactions ?
                                    <>
                                        {item &&
                                            <LiveDealershipActionForm
                                                item={item}
                                                updateDealerInfo={updateDealerInfo}
                                                handleFitAnalysisModal={handleFitAnalysisModal}
                                                backToResultBtn={backToResultBtn}
                                                index={index}
                                                transactions={item.live_dealership in dealershipData.live_transactions ? dealershipData.live_transactions[item.live_dealership] : []}
                                            />}
                                        {!isTabView &&
                                            <div className='aia-inner-table pm-inner-table pe-1-2'>
                                                <table className='w-100'>
                                                    <thead>
                                                        <tr>
                                                            {/* <th className='text-start' style={{ width: "15%" }}>Sold Date</th> */}
                                                            <th className='text-start' style={{ width: "35%" }}>Vehicle</th>
                                                            <th className='text-start' style={{ width: "20%" }}>VIN</th>
                                                            <th className='text-center' style={{ width: "10%" }}>Miles</th>
                                                            <th className='text-center' style={{ width: "15%" }}>List Price</th>
                                                            {/* <th className='text-start' style={{ width: "15%" }}>Sale Price</th> */}
                                                            {/* <th className='text-start' style={{ width: "15%" }}>Salesman</th> */}
                                                            <th className='text-center' style={{ width: "5%" }}>DOL</th>
                                                            <th className='text-start' style={{ width: "15%" }}></th>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        }
                                        {isTabView &&
                                            <div className='d-flex align-items-center justify-content-between mob-custom-tab-th'>
                                                <div>Vehicles</div>
                                            </div>
                                        }
                                        <div className='aia-inner-table pm-inner-table vertical-scroll'>
                                            {/* {console.log("dealershipData.live_transactions[item.live_dealership]", dealershipData.live_transactions[item.live_dealership])} */}
                                            <table className='w-100'>
                                                <tbody>
                                                    {dealershipData.live_transactions[item.live_dealership]?.map((v, j) => {

                                                        return (
                                                            <tr key={j}>
                                                                {/* <td style={{ width: "15%" }} className='text-start'>{v.sold_date}</td> */}
                                                                <td style={{ width: "35%" }} className='text-start'>{v.vehicle}</td>
                                                                <td style={{ width: "20%" }} className='text-start text-lred'>{v.vin}</td>
                                                                <td style={{ width: "10%" }} className={`text-center ${isTabView ? 'opacity-0-5' : ''}`}></td>
                                                                <td style={{ width: "15%" }} className={`text-md-center text-end ${isTabView ? 'font-1-1em' : ''}`}>{numberFormatter(v.sale_price, true)}</td>
                                                                {/* <td style={{ width: "15%" }} className='text-start'>{numberFormatter(v.sale_price, true)}</td> */}
                                                                {/* <td style={{ width: "15%" }} className='text-start'>{v.salesmen}</td> */}
                                                                {!isTabView &&
                                                                    <>
                                                                        <td style={{ width: "5%" }} className="text-center">{v.days_on_lot}</td>
                                                                        <td style={{ width: "15%" }} className='text-end'>
                                                                            <button type='button' className='red-btn sm-btn text-uppercase'
                                                                                onClick={() => openVautoAppraisal(v.vin, 1234)}
                                                                            >
                                                                                Send to Vauto
                                                                            </button>
                                                                        </td>
                                                                    </>
                                                                }
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                    :
                                    <div className='pm-loader'><LoadingModal /></div>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Current Tbale */}
            {/* <div className='custom-table'>
                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th className='text-start ps-4' onClick={() => requestSort('dealership')}>
                                Dealership
                                <span className='sort-icon ms-3'><img src={getImages('icon-sort.svg')} /></span>
                            </th>
                            <th>{dealershipData.vin_info.make_ss} Sold Last 30 Days</th>
                            <th>{dealershipData.vin_info.make_ss} Sold Last 90 Days</th>
                            <th>{dealershipData.vin_info.model_ss} Sold Last 30 Days</th>
                            <th>{dealershipData.vin_info.model_ss} Sold Last 90 Days</th>
                            <th>Vehicles on Lot</th>
                            <th>Location</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dealershipData.dealership_counts.map((item, index) => (
                            <React.Fragment key={index}>
                                <tr key={index} className={`${expandedRow === index && 'active'}`}>
                                    <td className='text-start'>
                                        <span className='dealership-name'><a className='pmt-label text-ellips' href={'/dealer-analysis?dealership=' + encodeURIComponent(item.marketcheck_name)} target="_blank">
                                            <span className='pmt-label'>{item.name}</span>
                                        </a>
                                        </span><br />{index == 0 && <span>*Best Match*</span>} ranking {item.ranking.toFixed(1)}
                                    </td>
                                    <td>
                                        <div className={`gradient-circle green-circle`}>
                                            <div className="gradient-circle-inside">{item.make_data.thirty_day_sold}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={`gradient-circle green-circle`}>
                                            <div className="gradient-circle-inside">{item.make_data.ninty_day_sold}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={`gradient-circle green-circle`}>
                                            <div className="gradient-circle-inside">{item.model_data.thirty_day_sold}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={`gradient-circle green-circle`}>
                                            <div className="gradient-circle-inside">{item.model_data.ninty_day_sold}</div>
                                        </div>
                                    </td>
                                    <td className='price'>{item.inventory_count}</td>
                                    <td className='distance'>{item.location}</td>
                                </tr>
                                {expandedRow === index && (
                                    <tr>
                                        <td colSpan={8} className='p-0'>
                                            <div className='table-accortion-box custom-form'>
                                                <div className='row align-items-end'>
                                                    <div className='col-md-9'>
                                                        <Formik
                                                            initialValues={{
                                                                phone: '954-556-1244',
                                                                script: '',
                                                                message: '',
                                                            }}
                                                            onSubmit={async (values, { resetForm }) => {
                                                                console.log(values);
                                                                resetForm();
                                                            }}
                                                        >
                                                            {({ values }) => (
                                                                <Form autoComplete="off" name="contact-form">
                                                                    <div className='row align-items-center'>
                                                                        <div className='col-md-3'>
                                                                            <label className="cs-label">Dealer Phone</label>
                                                                            <div className='position-relative'>
                                                                                <Field type='text' name='phone'
                                                                                    className='form-control pe-5'
                                                                                    placeholder='954-556-1244'
                                                                                    readOnly={!isEditable}
                                                                                />
                                                                                <button type='button'
                                                                                    className='edit-icon icon-pos'
                                                                                    onClick={toggleEdit}
                                                                                >
                                                                                    <img src={getImages('edit-material.svg')} />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-md-3'>
                                                                            <label className="cs-label">Select Script</label>
                                                                            <Field as='select' name='script' className='form-control'>
                                                                                <option>Select</option>
                                                                            </Field>
                                                                        </div>
                                                                        <div className='col-md-3'>
                                                                            <label className="cs-label opacity-0-5 mt-4">Optional</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='msg-box mt-4'>
                                                                        <div className='msg-cht'>
                                                                            <div className='msg-cht-scroll'>
                                                                                <div className='msg-cht-block mb-3'>
                                                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                                        <div className='xxs-title'>Joe Simpson</div>
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div className='ext-sm-title'>2:24PM</div>
                                                                                            <div className='ext-sm-title text-dgray ms-4'><strong>10/24/24</strong></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p>We are receiving lots of clients interested in 2022 Porsche 911, do you have any available. My client is ready to make an offer.</p>
                                                                                </div>
                                                                                <div className='msg-cht-block mb-3'>
                                                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                                        <div className='xxs-title'>Richard Nixon</div>
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div className='ext-sm-title'>11:00AM</div>
                                                                                            <div className='ext-sm-title text-dgray ms-4'><strong>Today</strong></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p>Yes, we sell a lot of those and have 5 on inventory, send you a link to our selection now <a href="https://www.autosales.com/listings">www.autosales.com/listings</a></p>
                                                                                </div>
                                                                                <div className='msg-cht-block mb-3'>
                                                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                                        <div className='xxs-title'>Joe Simpson</div>
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div className='ext-sm-title'>2:24PM</div>
                                                                                            <div className='ext-sm-title text-dgray ms-4'><strong>10/24/24</strong></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p>We are receiving lots of clients interested in 2022 Porsche 911, do you have any available. My client is ready to make an offer.</p>
                                                                                </div>
                                                                                <div className='msg-cht-block mb-3'>
                                                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                                        <div className='xxs-title'>Richard Nixon</div>
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div className='ext-sm-title'>11:00AM</div>
                                                                                            <div className='ext-sm-title text-dgray ms-4'><strong>Today</strong></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <p>Yes, we sell a lot of those and have 5 on inventory, send you a link to our selection now <a href="https://www.autosales.com/listings">www.autosales.com/listings</a></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='msg-action-box d-flex align-items-center'>
                                                                            <Field type='text' name='message' className='form-control' placeholder='Enter Text Message…' />
                                                                            <button type='submit' className='red-btn'>ENTER</button>
                                                                        </div>
                                                                    </div>
                                                                </Form>
                                                            )}
                                                        </Formik>
                                                    </div>
                                                    <div className='col-md-3 ps-60'>
                                                        <div className='mt-3'>
                                                            <button type='button' className='red-btn w-100 text-uppercase'>Photos</button>
                                                        </div>
                                                        <div className='mt-3'>
                                                            <button type='button' className='red-btn w-100 text-uppercase' onClick={handleNotesModal}>Notes</button>
                                                        </div>
                                                        <div className='mt-3'>
                                                            <button type='button' className='red-transparent-btn w-100 text-uppercase'>Email</button>
                                                        </div>
                                                        <div className='mt-3'>
                                                            <button type='button' className='red-transparent-btn w-100 text-uppercase'>Call</button>
                                                        </div>
                                                        <div className='mt-3'>
                                                            <button type='button' className='red-transparent-btn w-100 text-uppercase'>Dealer Site</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div> */}
        </>
    );
};

export default SortingTable;
